module.exports = __webpack_public_path__ + "static/media/Floating Bunny.5d8c85fe.mp4";